import React from 'react';
import clsx from 'clsx';

import { IProps } from './QuickLinksBlock.interface';
import './QuickLinksBlock.styles.css'; // Correct import for CSS modules

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component'; // Default import
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component'; // Default import
import Text from '@/elements/Text/Text.component'; // Default import
import Button from '@/elements/Button/Button.component'; // Default import

const QuickLinksBlock: React.FC<IProps> = ({
    heading,
    text,
    links,
    className,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper
            className={clsx('quickLinksBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                {/* Use align="center" for centering content within the column */}
                <ContentColumn align="center">
                    {heading && (
                        <Heading
                            level={2}
                            className="quickLinksBlock__heading"
                            html={heading}
                        />
                    )}
                    {text && (
                        // Removed size prop from Text
                        <Text className="quickLinksBlock__text" html={text} />
                    )}
                    {links && links.length > 0 && (
                        <div className="quickLinksBlock__links">
                            {links.map((link, index) => (
                                <Button
                                    key={`quicklinks-block-link-${index}`}
                                    {...link}
                                    as="a" // Render as anchor tag
                                    href={link.href} // Pass url to href
                                    icon="arrow-right" // Default icon
                                    iconPosition='after' // Default icon position
                                    variant="secondary" // Default variant: 'secondary' for outline style
                                    color="brand-1" // Default color based on image
                                    className={clsx('quickLinksBlock__link', link.className)} // Allow overriding class
                                />
                            ))}
                        </div>
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export default QuickLinksBlock;
export { QuickLinksBlock };
